import Behaviour from "../../lib/ui/Behaviour";
import { SimpleGLOverlay } from "./SimpleGLOverlay";
import { buildPathMesh } from "./PathRender";
import { Alt1 } from "../../lib/alt1/Alt1";
export class PathOverlayControl extends Behaviour {
    constructor() {
        super(...arguments);
        this._overlay = [];
    }
    async setIngameOverlays(paths) {
        if (!Alt1.instance().featureGL())
            return;
        this.reset();
        paths = paths.filter(p => !!p && p.length > 0);
        if (paths.length === 0)
            return;
        for (const path of paths) {
            this._overlay.push(new SimpleGLOverlay((await buildPathMesh(path)).finalize()).start());
        }
    }
    begin() {
    }
    reset() {
        if (this._overlay) {
            this._overlay.forEach(o => o.stop());
            this._overlay = [];
        }
    }
    end() {
        this.reset();
    }
}
